import { dispatcher } from 'dispatcher';

export default (openUrls) => {
    let actionHandler;

    if (openUrls && openUrls.length > 0 && openUrls[0].length > 0) {
        actionHandler = () => {
            dispatcher.dispatch('core:navigate', openUrls[0]);
        };
    }

    return { actionHandler };
};
